module.exports = __webpack_public_path__ + "img/close.0eb44dc1.svg";